import { useState } from "react";
import { Minus, Plus } from "lucide-react"; // Optional: You can use your own icons

const FAQSection = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-7xl  mx-auto px-4 py-20">
      <h2 className="text-3xl md:text-4xl font-bold text-orange-500 text-center mb-8">
        Frequently Asked  Questions
      </h2>

      {faqs.map((faq, index) => {
        const isOpen = openIndex === index;

        return (
          <div
            key={index}
            className="border-y border-primary"
          >
            <div
              className="flex justify-between items-center px-4 py-4 cursor-pointer bg-light text-secondary"
              onClick={() => toggleIndex(index)}
            >
              <h3 className="font-semibold text-lg md:text-xl">{faq.question}</h3>
              <div className="ml-4">
                {isOpen ? <Minus size={20} /> : <Plus size={20} />}
              </div>
            </div>

            {isOpen && (
              <div className="px-4 py-3 bg-gray-100 text-black text-md md:text-lg">
                {faq.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FAQSection;
